import { rankPages, type SearchPage } from './page-search.ts'

/** A request to review alerts. Search supplies navigation and never changes an alert. */
export interface ManageAlertsResult {
  href: string
  label: string
  description: string
}

/** Recognize alert management only when the viewer may open My alerts. */
export function searchManageAlerts(
  query: string,
  pages: readonly SearchPage[]
): ManageAlertsResult | null {
  const text = query
    .trim()
    .replace(/\s+/g, ' ')
    .replace(/[?.!]+$/, '')
  const named = /^(?:pause|resume|delete|edit) my (.+?) alerts?$/i.exec(text)
  if (
    !named &&
    !/^(?:what alerts do i have|my alerts|show my alerts)$/i.test(text)
  )
    return null
  const destination = pages.find(
    entry => entry.page.id === 'alerts-rules'
  )?.page
  if (!destination) return null
  const report = named
    ? rankPages(
        pages.filter(entry => entry.page.id !== 'alerts-rules'),
        named[1]
      )[0]?.page
    : null
  return {
    href: destination.path,
    label: 'Open My alerts',
    description: report
      ? `Find the ${report.title} alert there. Search never changes an alert.`
      : 'Review your alerts there. Search never changes an alert.'
  }
}
